import React from "react";

import { compose, graphql, Query } from "react-apollo";
import { useAuthDispatch, useAuthState } from "../../Context";
import { useNavigate } from "react-router-dom";
import { getUtilisateur } from "../../../api/queries/utilisateur.queries";
import Loader from "../../components/Loader";
import ValidatedMyAccountForm from "../../components/ValidatedMyAccountForm";

function EntrepriseCompte(props) {
  const dispatch = useAuthDispatch();
  const navigate = useNavigate();
  const authContext = useAuthState(); //read user de

  const { userDetails = {} } = authContext;
  const { id: utilisateurId, login, email, token } = userDetails;

  return (
    <Query
      query={getUtilisateur}
      variables={{ utilisateurId }}
      fetchPolicy="no-cache"
    >
      {({ loading, error, data = {}, refetch }) => {
        if (loading) return <Loader />;
        if (error) return "Erreur";


        const { entreprises = [] } = data.getUtilisateur;

        return (
          <div>
            {" "}
            <h1 className="dashboardTitle pushed">Détails du compte</h1>
            <div className="row pushedByMenu">
              <div className="col-md-12">
                <h3>Profil utilisateur</h3>
              </div>
              <div className="pushedContainer">
                {entreprises.map(entreprise => {
                  const { denomination } = entreprise;

                  return <p>{denomination}</p>;
                })}
              </div>
            </div>
          </div>
        );
      }}
    </Query>
  );
}

export default EntrepriseCompte;
